module.exports = __webpack_public_path__ + "img/hw-q990b.e7f4cb25.png";